import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { Footer } from 'components/Footer/Footer'
import SnackBarMsg from 'components/SnackBar/SnackBarMsg'
import { usePermissionChecker } from 'containers/helper/hooks/usePermissionChecker'
import { useSnackBar } from 'containers/helper/hooks/useSnackBar'
import { IAction } from 'containers/helper/models'
import { amtStr } from 'containers/helper/numFormatter'
import { Filter } from 'containers/helper/SearchFilter'
import hotelmayalogo from '../../../assets/images/HotelMaya/HotelMayaSide.png'
import ShareDialog, { htmlConverter } from 'containers/helper/Share'
import {
  HotelPermission,
  TaxType,
  useBiSharedGAlleryInsertMutation,
  useBiUsersLisitingQuery,
  useDocumentTemplateListQuery,
  useEmailSendMutation,
  useFolioDetailsLazyQuery,
  useGetHotelLatestTaxQuery,
  useHotelDetailsQuery,
  useDepositClassQuery,
  usePaymentDetailsQuery,
  useOutGoingDocTemplateLazyQuery,
  useDebtorFolioInfoQuery,
  useAdvancePaymentDetailsQuery,
  useAdvancePaymentReversedDetailsQuery,
  useFolioDetailsQuery
} from 'generated/graphql'
import React, { useEffect, useState, Reducer, useReducer } from 'react'
import { useHistory, useLocation } from 'react-router'
import { TypesRoute } from '../BusinessRoute'
import AddressConverter from './addressConverter'
import { DocSelectionDialog } from './DocSelectionDialog'
import { useReceipt } from './hooks/useReceipt'
import { useInvoice } from './hooks/useInvoice'
import { usePreventRefresh } from 'containers/helper/hooks/usePreventRefresh'
import { HotelXFolio } from './CustomizedDocument/Default/Folio'
import { HotelXFolioHotelMaya } from './CustomizedDocument/Default/FolioHotelMaya'
import { HotelXReceipt } from './CustomizedDocument/Default/Receipt'
import { useGetTaxScheme } from 'containers/CommonSettingsModule/TaxScheme/hooks/useGetTaxScheme'
import { AdvanceForfeitDocumentMaya } from './CustomizedDocument/Maya/AdvanceForfeitDocument'
import { AdvanceForfeitDocumentPHKK } from './CustomizedDocument/Promenade/AdvanceForfeitDocument'
import { AdvanceForfeitDocumentPHB } from './CustomizedDocument/PromenadeBintulu/AdvanceForfeitDocument'
import { AdvanceForfeitDocumentImperial } from './CustomizedDocument/Imperial/AdvanceForfeitDocument'
import { differenceInDays } from 'date-fns'

interface Props {
  mode?: string
  type?: string
}
interface Document {
  dialog?: boolean
  signatureUrl?: null | undefined
}
interface props {
  DocSelectionDialog?: boolean
  ButtonType?: string
  DocList?: any[]
  DocSelected?: string
}
export const AdvanceForfeitDocument = (props: Props) => {
  const { handleKeyDown, handleRightClick } = usePreventRefresh()
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('contextmenu', handleRightClick)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('contextmenu', handleRightClick)
    }
  }, [])
  const dateFormat = require('dateformat')
  const { mode, type } = props
  const history = useHistory()
  const [simple, setSimple] = useState(false)
  const [imgUrl, setimgUrl] = useState(null)
  const location = useLocation()
  const { handlePermDisabled } = usePermissionChecker()
  const [emailShare, setEmailShare] = useState(false)
  const [sendEmail, setSendEmail] = useState(false)
  const [EmailAddress, setEmailAddress] = useState('')
  const { snackFunc, snackBarMessage, openSnackBar } = useSnackBar()
  const stateInfo: any = location.state

  const initialState: props = {
    DocSelectionDialog: false,
    ButtonType: '',
    DocSelected: '',
    DocList: [],
  }
  const reducer: Reducer<props, IAction> = (state, action) => {
    switch (action.type) {
      case 'Reset':
        return initialState

      default:
        return { ...state, [action.type]: action.payload }
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState)
  console.log(state)
  console.log('state info: ', stateInfo)
  const TransactionType = {
    Package: 'Package',
    Rate: 'Rate',
  }
  const { data: { HotelDetails } = { HotelDetails: null } } =
    useHotelDetailsQuery({
      variables: {
        HotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
      },
      fetchPolicy: 'no-cache',
    })
  // const [
  //   Details,
  //   {
  //     loading: Loadings,
  //     data: { FolioDetails } = {
  //       FolioDetails: null,
  //     },
  //   },
  // ] = useFolioDetailsLazyQuery({
  //   variables: {
  //     ID: stateInfo?.FolioID || stateInfo?.Folio?.ID,
  //     HotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
  //   },
  //   fetchPolicy: 'no-cache',
  // })


  const { data: { AdvancePaymentDetails } = { PayAdvancePaymentDetailsmentDetails: null } } =
    useAdvancePaymentDetailsQuery({
      variables: {
        ID: stateInfo?.ID,
        HotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
      },
      fetchPolicy: 'no-cache',
    })


  const { data: { AdvancePaymentReversedDetails } = { AdvancePaymentReversedDetails: null } } =
    useAdvancePaymentReversedDetailsQuery({
      variables: {
        ID: AdvancePaymentDetails?.ReversedAdvancePaymentID || null,
        HotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
      },
      fetchPolicy: 'no-cache',
    })

  const
    {
      loading: Loadings,
      data: { FolioDetails } = {
        FolioDetails: null,
      },
    }
      = useFolioDetailsQuery({
        variables: {
          ID: stateInfo?.FolioID || stateInfo?.Folio?.ID,
          HotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
        },
        fetchPolicy: 'no-cache',
      })

  const [
    Template,
    {
      loading: Loadingtemp,
      data: { OutGoingDocTemplate } = {
        OutGoingDocTemplate: null,
      },
    },
  ] = useOutGoingDocTemplateLazyQuery({
    variables: {
      HotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
    },
    fetchPolicy: 'no-cache',
  })


  const { data: { DebtorFolioInfo } = { DebtorFolioInfo: null, }, } =
    useDebtorFolioInfoQuery({
      variables: {
        HotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
        DebtorAccount: AdvancePaymentDetails?.DebtorAccount || null
      },
      fetchPolicy: 'no-cache',
    })

  useEffect(() => {
    Template()
  }, [HotelXFolio])

  useEffect(() => {
    if (stateInfo?.FolioID || stateInfo?.Folio?.ID) {
      Template()
    } else {
      Template()
    }
  }, [stateInfo?.FolioID || stateInfo?.Folio?.ID])

  const [EmailSend, { loading: loadingInsert }] = useEmailSendMutation()
  const ShareButton = {
    title: `${JSON.parse(localStorage.getItem('Hotel'))?.HotelName
      } has shared you a folio-${AdvancePaymentDetails?.Folio?.FolioNo
      } `,
    url: imgUrl,
    img: `Click Here`,
  }

  useEffect(() => {
    var Email = ''
    Email =
      AdvancePaymentDetails?.Booking?.Contact?.Email

    if (Email !== '') {
      setEmailShare(true)
      setEmailAddress(Email)
    }
  }, [AdvancePaymentDetails])

  useEffect(() => {
    sendEmail &&
      EmailSend({
        variables: {
          Body: {
            Header: `${ShareButton.title}`,
            Body: FormContent,
          },
          HotelID: JSON.parse(localStorage.getItem('Hotel')).ID,
          Email: EmailAddress,
        },
      }).then(w => {
        if (w.data.EmailSend === true) {
          snackFunc('Sent Email Successfully!', false)
          setSimple(false)
        } else {
          snackFunc('Sent Email Fail!', false)
        }
      })
  }, [sendEmail])

  

  let PackagesPrice = 0
  var NumberCount = 1
  // const SelectedItem =[FolioDetails?.BillLedger, FolioDetails?.RoomCharges, FolioDetails?.Payment?.filter(x=>x?.PaymentClass === 'Advance')].filter(Boolean).flat(10) as any;
  const SelectedItem = [AdvancePaymentDetails]
    ?.filter(Boolean)
    ?.flat(10) as any


  const iscityledgerdocs = () => {
    if (AdvancePaymentDetails?.Folio?.FolioNo !== null) {
      if (AdvancePaymentDetails?.Folio?.DocumentType !== null) {
        if ((AdvancePaymentDetails?.Folio?.DocumentType?.startsWith('CN') || AdvancePaymentDetails?.Folio?.DocumentType?.startsWith('DN')
          || AdvancePaymentDetails?.Folio?.DocumentType?.startsWith('OR') ||
          AdvancePaymentDetails?.Folio?.DocumentType?.startsWith('RF')) && OutGoingDocTemplate?.Folio !== null) {
          return true;
        } else {
          return false
        }
      } else {
        if ((AdvancePaymentDetails?.Folio?.FolioNo?.startsWith('CN') || AdvancePaymentDetails?.Folio?.FolioNo?.startsWith('DN')
          || AdvancePaymentDetails?.Folio?.FolioNo?.startsWith('OR') ||
          AdvancePaymentDetails?.Folio?.FolioNo?.startsWith('RF')) && OutGoingDocTemplate?.Folio !== null) {
          return true;
        }
        else {
          return false
        }
      }
    }
    else {
      return false
    }


  }

  const isnegativeamount = (Amount_: number, payment) => {

    const converterbar = Number(Amount_) < 0
      ?

      `(${amtStr((Amount_) * -1)})`
      : payment === 'payment' ? `(${amtStr((Amount_))})` : amtStr((Amount_))

    const converterbar2 = Number(Amount_) < 0

    return payment?.hasOwnProperty('PaymentType') && 
      ((payment?.DocumentType === null && !payment?.ReceiptNo?.startsWith('HTRF')) ||
      (payment?.DocumentType !== null && !payment?.DocumentType?.startsWith('HTRF'))) && 
      !converterbar2 
        ? `(${ converterbar})` 
        : converterbar
  }

  const isRoundingnegativeamount = (Amount_: number, payment, mode?) => {
    let converterbar2
    let converterbar

    if (mode === 'CN') {
      converterbar2 = Number(Amount_) < 0 ? `(${amtStr((Amount_ * -1))})` : amtStr((Amount_))
      // converterbar2 = amtStr((Amount_ ))
    } else {
      converterbar = Number(Amount_) < 0 ? amtStr((Amount_ * -1)) : `(${amtStr((Amount_))})`
    }



    return mode === 'CN' ? converterbar2 : converterbar
  }


  var desc = [(`
      
  <tr  
  class="room-detail" 
  style="
  font-family: 'Poppins';
  -webkit-print-color-adjust: exact;
  -webkit-text-size-adjust:none;
  border: 2px solid #fff;
  background-color: #fff;
  color:'#212121';
    font-size: 10px;
    line-height: 15px;
    text-align: center;">
<td style={"text-align: center; font-family: 'Poppins';
-webkit-print-color-adjust: exact;
-webkit-text-size-adjust:none;
border: 2px solid #fff;"}>${dateFormat(AdvancePaymentDetails?.PaymentDate, 'dd/mm/yyyy')}</td>
<td style="text-align: left; line-height: 1.2;   font-family: 'Poppins';">${'Forfeited Advance Booked'} </td>
${OutGoingDocTemplate === null
      ? `<td style="text-align: center;   font-family: 'Poppins';">${''
      }</td>`
      : ''
    }
<td style={"font-family: 'Poppins';
-webkit-print-color-adjust: exact;
-webkit-text-size-adjust:none;
border: 2px solid #fff;"}>${AdvancePaymentDetails?.ReferenceNo}</td>
<td style="text-align: right; font-family: 'Poppins';
-webkit-print-color-adjust: exact;
-webkit-text-size-adjust:none; padding-right: 2%;">${amtStr(Number(AdvancePaymentDetails?.Amount.toFixed(2)) - Number(AdvancePaymentDetails?.TaxAmount.toFixed(2) || 0) - Number(AdvancePaymentDetails?.ServiceCharge.toFixed(2) || 0))}</td>
</tr>
`)]
  //Arr to Object
  var item = Object.assign({}, desc)
  //Object to string
  var EachFolioItem = ''
  for (const [key, value] of Object.entries(item)) {
    EachFolioItem = EachFolioItem + value
  }
  console.log(stateInfo, mode, 'stateInfo')
  const {
    loading,
    data: { DocumentTemplateList } = { DocumentTemplateList: null },
  } = useDocumentTemplateListQuery({
    variables: {
      ID: '0b3756c6-e0f9-4b11-b411-1690cacf76a1',
    },
    fetchPolicy: 'no-cache',
  })

  // const BIcreatedByID = stateInfo?.Selecteditem[0]?.Registration?.Booking?.CreatedBy
  const [BISharedGAlleryInsert, { loading: loadingSum }] =
    useBiSharedGAlleryInsertMutation()
  const {
    data: { BIUsersLisiting } = {
      BIUsersLisiting: null,
    },
  } = useBiUsersLisitingQuery({
    variables: {
      ID: AdvancePaymentDetails?.CreatedBy,
    },
  })
  //Multiple Tax and qurey
  const {
    data: { GetCurrentGovTax, GetServiceChargeTax } = {
      GetCurrentGovTax: [],
      GetServiceChargeTax: [],
    },
  } = useGetHotelLatestTaxQuery({
    variables: {
      HotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
    },
    fetchPolicy: 'no-cache',
  })

  function getSum(total, num) {
    return total + num
  }
  const isSelectedItemGovTax = SelectedItem?.some(
    x => x?.TaxType === TaxType.GovTax
  )

  const { InvoiceTemplate } = useInvoice({
    type: type,
    stateInfo: stateInfo,
    HotelDetails: HotelDetails,
    FolioDetails: null,
    BIUsersLisiting: BIUsersLisiting,
    GetCurrentGovTax: GetCurrentGovTax,
    GetServiceChargeTax: GetServiceChargeTax,
    FolioDetailsWithIDs: null,
    DebtorFolioInfo: DebtorFolioInfo,
    AdvancePaymentDetails: AdvancePaymentDetails,
    DepositClass: ''
  })

  const onSubmit = blob => {
    BISharedGAlleryInsert({
      variables: {
        HotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
        AttachmentInput: blob,
      },
    }).then(i => {
      i.data.BISharedGAlleryInsert
        ? setimgUrl(i.data.BISharedGAlleryInsert.Gallery.ImageURL)
        : console.log('false')
    })
  }

  console.log(stateInfo, 'stateInfo')

  const subAmount = (SelectedItem?.reduce((acc, curr) => {
    return acc + (curr.Amount || 0)
  }, 0) || 0)



  let newitem2: string = ``

  if (AdvancePaymentReversedDetails !== null) {
    AdvancePaymentReversedDetails?.map((x, y) => {
      let item = `
        <tr  
        class="room-detail" 
        style="
          font-family: 'Poppins';
          -webkit-print-color-adjust: exact;
          -webkit-text-size-adjust:none;
          border: 0px solid #fff;
          background-color: #fff;
          color: #2c2c2c;
          font-size: 10px;
          line-height: 15px;
          text-align: center;">
          <td style="text-align: center;   font-family: 'Poppins';">${dateFormat(x?.PaymentDate, 'dd/mm/yyyy')}</td>
          <td style="text-align: left;   font-family: 'Poppins';">${x?.PaymentClass === 'Refund' 
            ? `Refund by ${x.PaymentType  === "BankTT" ? "Bank TT" : x?.PaymentType} ${x?.PaymentCode ? ` - ${x?.PaymentCode}` : ''}` 
            : `${x.PaymentType  === "BankTT" ? "Bank TT" : x?.PaymentType} ${x?.PaymentCode ? ` - ${x?.PaymentCode}` : ''} Payment`}</td>
          <td style="text-align: center;   font-family: 'Poppins';">
          </td>
   
          <td style="text-align: left;  font-family: 'Poppins'; padding-left:0px;">${x?.ReceiptNo}</td>
   
          <td style="text-align: right; padding-right: 2%;   font-family: 'Poppins';">
          ${x?.PaymentClass !== 'Refund' && x?.Amount < 0 && x?.ReversedAdvancePaymentID !== x?.ID ? amtStr(-x?.Amount) : isnegativeamount(Number(x?.Amount), x)
        }</td>
    </tr>`

      newitem2 = `` + newitem2.concat(item)
    })
  }

  const outstandingbalancetemplate = `	  <div style="width: 100%; display: flex; margin-top: 10px;">
                        
<div style="width: 50%;  margin: 4px; padding: 6px; ">

</div>

<div style="width: 50%; display: block; padding-left: 15%;padding-right: 6px;">
       
       <table width="100%" border="0" cellspacing="0" cellpadding="0"  style="margin-bottom: 10px; font-family: 'Poppins';
   -webkit-print-color-adjust: exact;
   -webkit-text-size-adjust:none;" >

<tr class="" style="      background-color: #fff;
           color: #2c2c2c;
           font-size: 10px;
           line-height: 15px;
           ;
           ">
               <td style="
               font-weight: 800; padding-left: 0px; font-family:'Poppins';">OUTSTANDING BALANCE</td>
               <td style="
               font-weight: 800; font-family:'Poppins';  item-align:right; text-align: right; padding-left: 5px;
               color:#2c2c2c
               ">${(isnegativeamount(Number(0), ''))}</td>
<td style="width:4%;
               "></td>
           </tr>
       </table>
</div>

</div>`

  const outstandingbalanceFunc = () => {
    let result = ''

    if (iscityledgerdocs() === true || isinvoice() === false) {
      result = ''
    }
    else {
      result = outstandingbalancetemplate
    }
    return result
  }

  let address =
    AdvancePaymentDetails?.Folio?.BeneficiaryAddress ||
    AddressConverter({
      address: AdvancePaymentDetails?.Booking?.Contact?.Address?.address,
      address2: AdvancePaymentDetails?.Booking?.Contact?.Address?.address2,
      city: AdvancePaymentDetails?.Booking?.Contact?.Address?.city,
      country: AdvancePaymentDetails?.Booking?.Contact?.Address?.country,
      postCode: AdvancePaymentDetails?.Booking?.Contact?.Address?.postCode,
      state: AdvancePaymentDetails?.Booking?.Contact?.Address?.state,
    })
  const isinvoice = () => {

    if ((AdvancePaymentDetails?.Folio?.DocumentType === null && AdvancePaymentDetails?.Folio?.FolioNo?.startsWith('INV')) ||
    (AdvancePaymentDetails?.Folio?.DocumentType !== null && AdvancePaymentDetails?.Folio?.DocumentType?.startsWith('INV'))
    ) {
      return true;
    }
    else if (
      (AdvancePaymentDetails?.Folio?.DocumentType === null &&  
        (AdvancePaymentDetails?.Folio?.FolioNo?.startsWith('CN') || AdvancePaymentDetails?.Folio?.FolioNo?.startsWith('DN') || 
        AdvancePaymentDetails?.Folio?.FolioNo?.startsWith('OR') || AdvancePaymentDetails?.Folio?.FolioNo?.startsWith('RF'))
      ) || (AdvancePaymentDetails?.Folio?.DocumentType !== null &&  
        (AdvancePaymentDetails?.Folio?.DocumentType?.startsWith('CN') || AdvancePaymentDetails?.Folio?.DocumentType?.startsWith('DN') || 
        AdvancePaymentDetails?.Folio?.DocumentType?.startsWith('OR') || AdvancePaymentDetails?.Folio?.DocumentType?.startsWith('RF')))
    ) {

      return true;
    }

    else {
      return false
    }
  }
  //maya only <3
  const agentname = () => {
    let result = ''

    if (OutGoingDocTemplate !== null && DebtorFolioInfo !== null) {

      result = `Bill To :`

    }
    else {
      result = (!AdvancePaymentDetails?.Booking?.Debtor?.DebtorAccount && !AdvancePaymentDetails?.Booking?.Debtor?.DebtorAccount)
        ? ''
        : `Company/Travelling Agent Name:${AdvancePaymentDetails?.Booking?.Debtor?.Name || AdvancePaymentDetails?.Booking?.Debtor?.Name}`
    }

    return result;

  }

  console.log(HotelDetails, type, "hotel:")


  const taxListing = () => {
    let taxList: any = []
    let roomTaxGrouping: any = []
    let billTaxGrouping: any = []

    if (FolioDetails?.AdvancePayment?.length > 0) {

      if (FolioDetails?.AdvancePayment?.length > 0 && stateInfo?.FolioType !== 'NonGuest') {
        roomTaxGrouping = []?.concat(
          ...FolioDetails?.AdvancePayment?.map(x => {
            if (x?.ForfeitTax
            ) {
              return x?.ForfeitTax

            } else {
              return
            }
          })?.filter(y => y !== undefined)
        )
      }
      const Listing = roomTaxGrouping?.concat(billTaxGrouping)

      taxList = Listing?.reduce((acc, curr) => {
        const { TaxID, TaxInfo, TaxAmount, TaxRate } = curr

        const existing = acc.find((x) => x.TaxID === TaxID)

        if (existing) {
          existing.TaxAmount += TaxAmount
        } else {
          acc.push({TaxID, TaxRate, TaxInfo, TaxAmount})
        }

        return acc;
      }, [])
    }
  
    

    return taxList
  }

  const { data } = useGetTaxScheme({
    TaxOutput: stateInfo?.Tax || taxListing(),
    Type: 'NonGuest',
  })

  const HotelMayaTax = (stateInfo?.Tax || taxListing())?.map(x => {
    return `
    <tr
      class="" 
      style="background-color: #fff;
      color: #2c2c2c;
      font-size: 10px;
      line-height: 15px;"
    >
      <td
        style="font-weight: 300; padding-left: 6px;"
      >
        ${x?.TaxInfo?.code || x?.taxCode || x?.TaxCode} (${x?.TaxRate || x?.taxRate || x?.TaxRate}%)
      </td>
      <td
        style="font-weight: 300; item-align:right; text-align: right;"
      >
        ${isnegativeamount(Number(x?.TaxAmount || x?.taxAmount || x?.Value || 0.00), '')}
      </td>
    </tr>
  `
  })
  console.log(data,taxListing(),'test')
  var docItem = Object.assign({}, HotelMayaTax)
  //Object to string
  var HotelMayaTaxItem = ''
  for (const [key, value] of Object.entries(docItem)) {
    HotelMayaTaxItem = HotelMayaTaxItem + value
  }

  const totaltaxamount = taxListing()?.reduce((acc, curr) => {
    return acc + Number(curr?.TaxAmount || curr?.taxAmount )
  }, 0) || 0

  const conditionSub = subAmount - totaltaxamount

  const AmountItem = `
    <div style="width: 100%; display: flex; margin-top: 5px;">                 
      <div style="width: 50%;  margin: 4px; padding: 6px; "></div>
      <div style="width: 50%; display: block; padding-left: 25%;padding-right: 3px;">  
        <table 
          width="100%" border="0" cellspacing="0" cellpadding="0"  
          style="margin-bottom: 12px; font-family: 'Poppins'; -webkit-print-color-adjust: exact; -webkit-text-size-adjust:none;" 
        >
          <tr 
            class="" 
            style="background-color: #fff;
              color: #2c2c2c;
              font-size: 10px;
              line-height: 15px;"
          >
            <td style="font-weight: 300; padding-left: 6px;">
              Sub Total
            </td>
            <td style=" font-weight: 300; item-align:right; text-align: right;">
              ${isnegativeamount(conditionSub,'')}
            </td>
            <td style="width:4%;"></td>
          </tr>
          
          ${OutGoingDocTemplate?.Folio ? HotelMayaTaxItem || '' : data || ''}

          <tr 
            class="" 
            style="background-color: #fff;
              color: #2c2c2c;
              font-size: 10px;
              line-height: 15px;"
          >
            <td style=" font-weight: 300; padding-left: 6px;">
              Rounding
            </td>
            <td style="font-weight: 300;  item-align:right;text-align: right;">
              ${amtStr(0)}
            </td>
          </tr>
          <tr 
            class="" 
            style="background-color: #fff;
              color: #2c2c2c;
              font-size: 10px;
              line-height: 15px;"
          >
            ${''}
          </tr>
          <tr 
            class="" 
            style="background-color: #fff;
            color: #2c2c2c;
            font-size: 10px;
            line-height: 15px;"
          >
            ${''}
          </tr>
          <tr 
            class="" 
            style="background-color: #fff;
              color: #2c2c2c;
              font-size: 10px;
              line-height: 15px;"
          >
              <td style="font-weight: 800; padding-left: 6px;">
                TOTAL
              </td>
              <td style="font-weight: 800;  item-align:right; text-align: right; color:#2c2c2c">
                ${isnegativeamount(Number(AdvancePaymentDetails?.Amount), '')}
              </td>
              <td style="width:4%;"></td>
          </tr>
        </table>
      </div>   
    </div>`

  const eInvoiceQr = () => {
    const condition = FolioDetails?.is_einvoice === true && 
      HotelDetails?.Company?.isEInvIntegrated === true &&
      dateFormat(FolioDetails?.FolioDate, 'yyyy-mm-dd') >= dateFormat(HotelDetails?.Company?.eInvStartDate, 'yyyy-mm-dd') &&
      dateFormat(FolioDetails?.FolioDate, 'yyyy-mm-dd') <= dateFormat(HotelDetails?.Company?.eInvEndDate, 'yyyy-mm-dd') &&
      FolioDetails?.QrCodeUrl !== null

    const result = condition === true 
      ? `<td class="qr-code" rowspan="5"; style="width:100%; text-align:right; justify-content:end; position: relative; vertical-align: center">
          <span style="display: flex; justify-content: center; text-align: center; padding-bottom: 4px">
            <img 
              src="${FolioDetails?.QrCodeUrl}"
              alt="QR Code" 
              style="width: 85px; display: inline-block;"
            >
          </span>
          <div style="width: 100%; right: 0; line-height: 1">
            <span style="font-size:9px; display: flex; justify-content: center; text-align: center;">
              ${HotelDetails?.ID === '4e09073e-189e-4a82-b456-16eb56f49890'
                ? 'Scan to request e-invoice' 
                : 'Scan within 72 hours if'}
            </span>
            <span style="font-size:9px; display: flex; justify-content: center; text-align: center;">
              ${HotelDetails?.ID === '4e09073e-189e-4a82-b456-16eb56f49890'
                ? 'Last request date: 3rd calendar day of the following month'
                : 'e-Invoice is required'}
            </span>
            ${HotelDetails?.ID === '4e09073e-189e-4a82-b456-16eb56f49890'
              ? `<span style="font-size:9px; display: flex; justify-content: center; text-align: center;">
                  3rd calendar day of the following month
                </span>` 
              : ''
            }
          </div>
        </td>`
      :``
    return result;
  }

  const eInvoiceUniqueID = () => {
    const isCondition = FolioDetails?.is_einvoice === true && 
      HotelDetails?.Company?.isEInvIntegrated === true &&
      dateFormat(FolioDetails?.FolioDate, 'yyyy-mm-dd') >= dateFormat(HotelDetails?.Company?.eInvStartDate, 'yyyy-mm-dd') &&
      dateFormat(FolioDetails?.FolioDate, 'yyyy-mm-dd') <= dateFormat(HotelDetails?.Company?.eInvEndDate, 'yyyy-mm-dd')
    
    const resUniqueID = isCondition
        ? 'UUID : ' + (FolioDetails?.einvoice_uniqueID !== '' ? FolioDetails?.einvoice_uniqueID : '-')
        : ''
    return resUniqueID
  }

  var mapObj: any = {
    //Hotel
    '!!HotelName!!':` ${HotelDetails?.Company?.name} (${HotelDetails?.Company?.companyRegNo})`,
    '!!HotelImage!!': !JSON.parse(localStorage.getItem('Hotel'))?.LogoImage
      ? 'https://hotelx-dev.ifca.io/document/ifca.png'
      : JSON.parse(localStorage.getItem('Hotel'))?.LogoImage.ImageURL,
    '!!HotelEmail!!': !HotelDetails?.['Contact']
      ? ''
      : !HotelDetails?.['Contact']?.['BusinessEmail']
        ? ''
        : HotelDetails?.['Contact']?.['BusinessEmail'],
    '!!SSTRegNo!!': !HotelDetails?.Company?.['sstNo'] || HotelDetails?.Company?.['sstNo'] === 'NA' ? '' : '(SST Reg No: ' + HotelDetails?.Company['sstNo'] + ')',
    '!!TTXRegNo!!': !HotelDetails?.Company?.['ttxNo'] || HotelDetails?.Company?.['ttxNo'] === 'NA' ? '' : '(TTX Reg No: ' + HotelDetails?.Company['ttxNo'] + ')',
    '!!TINNo!!':
      !HotelDetails?.Company?.['tin'] || !HotelDetails?.Company?.['isEInvIntegrated']
        ? ''
        : differenceInDays(
            new Date(dateFormat(AdvancePaymentDetails?.Folio?.FolioDate, 'yyyy-mm-dd')),
            new Date(dateFormat(HotelDetails?.Company?.['eInvStartDate'], 'yyyy-mm-dd'))
          ) < 0
          ? ''
          : '(TIN No: ' + HotelDetails?.Company['tin'] + ')',
    '!!HotelMobileNo!!': !HotelDetails?.['Contact']?.['PhoneNo']
      ? ''
      : HotelDetails?.['Contact']?.['PhoneNo'],
    '!!HotelFaxNo!!': HotelDetails?.Contact.FaxNo || '',
    '!!HotelPhone!!': HotelDetails?.Contact.MobileNo || '',
    '!!HotelCustomAddress!!':
      ` <p style="color:#2c2c2c">
      ${HotelDetails?.['HotelAddress']?.['address']
        .concat(' ')
        .concat(HotelDetails?.['HotelAddress']?.['postCode'])}
      <br> ${HotelDetails?.['HotelAddress']?.['state']}${' '}${HotelDetails?.['HotelAddress']?.['country']
      }</p>` || '',
    '!!HotelWebsite!!': !HotelDetails?.['Contact']?.['WebUrl']
      ? ''
      : HotelDetails?.['Contact']?.['WebUrl'],

    '!!HotelAddress!!': HotelDetails?.['HotelAddress']
      ? AddressConverter({
        address: HotelDetails?.['HotelAddress']?.['address'],
        state: HotelDetails?.['HotelAddress']?.['state'],
        postCode: HotelDetails?.['HotelAddress']?.['postCode'],
        city: HotelDetails?.['HotelAddress']?.['city'],
        country: HotelDetails?.['HotelAddress']?.['country'],
      })
      : '',

    '!!FolioNo!!': AdvancePaymentDetails?.Folio?.FolioNo || '',

    '!!FOLIO!!': 'INVOICE',

    //Header top
    '!!CashierName!!': BIUsersLisiting?.name,
    '!!Date!!': dateFormat(AdvancePaymentDetails?.Folio?.FolioDate, 'dd/mm/yyyy'),
    '!!RoomNo!!': '',

    '!!BeneficiaryName!!': AdvancePaymentDetails?.Folio?.BeneficiaryName || '',

    '!!AgentName!!': agentname(),

    '!!GuestName!!':
      (OutGoingDocTemplate !== null && DebtorFolioInfo !== null ? `<td><td/>` :
        AdvancePaymentDetails?.Booking?.Contact?.FullName),

    '!!GuestMobileNo!!':
      (AdvancePaymentDetails ? OutGoingDocTemplate !== null ? 'N/A' :
        AdvancePaymentDetails?.Booking?.Contact?.MobileNo || '' : '') || ''

    ,
    '!!GuestEmail!!':
      AdvancePaymentDetails ?
        OutGoingDocTemplate !== null ? 'N/A'
          : AdvancePaymentDetails?.Booking?.Contact?.Email || ''
        : '' || '',

    '!!GuestAddress!!': OutGoingDocTemplate !== null &&
      DebtorFolioInfo ?
      AddressConverter({
        address: DebtorFolioInfo.Contact?.Address?.address,
        address2: DebtorFolioInfo?.Contact?.Address?.address2,
        city: DebtorFolioInfo?.Contact?.Address?.city,
        country: DebtorFolioInfo?.Contact?.Address?.country,
        postCode: DebtorFolioInfo?.Contact?.Address?.postCode,
        state: DebtorFolioInfo?.Contact?.Address?.state,
      })
      : address || ''
    ,

    '!!IdentityCard!!':
      AdvancePaymentDetails ?
        OutGoingDocTemplate !== null ? 'N/A'
          : AdvancePaymentDetails?.Booking?.Contact?.NRIC
        : '',

    '!!ArrivalDate!!':
      (OutGoingDocTemplate !== null ? 'N/A' :
        dateFormat(AdvancePaymentDetails?.Booking?.ArrivalDate, 'dd/mm/yyyy')) || '',

    '!!ArrivalTime!!': dateFormat(AdvancePaymentDetails?.Booking?.ArrivalDate, 'hh:MM:ss TT'),

    '!!DepartureDate!!':
      (OutGoingDocTemplate !== null ? 'N/A' :
        dateFormat(AdvancePaymentDetails?.Booking?.DepartureDate, 'dd/mm/yyyy')) || '',

    '!!DepartureTime!!': dateFormat(AdvancePaymentDetails?.Booking?.DepartureDate, 'hh:MM:ss TT'),

    '!!BookingNo!!':
      (OutGoingDocTemplate !== null ? 'N/A' :
        AdvancePaymentDetails?.Booking?.BookingNo || '') || ''
    ,
    //description

    //customtd 
    '!!ICtd!!': DebtorFolioInfo === null ? `  <td style="font-size:10px; font-weight: 400;   line-height: 18px; width:50%;">
         IC &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: ${AdvancePaymentDetails ?
        OutGoingDocTemplate !== null ? 'N/A'
          :

          AdvancePaymentDetails?.Booking?.Contact?.NRIC ||
          AdvancePaymentDetails?.Booking?.Contact?.PassportNo || ''

        : AdvancePaymentDetails?.Booking?.Contact?.PassportNo
      } </td>` : '',
    '!!phonetd!!': DebtorFolioInfo === null ? `  <td style="font-size:10px; font-weight: 400;  line-height: 18px; width:50%;">
         Phone : ${AdvancePaymentDetails ?
        OutGoingDocTemplate !== null ? 'N/A' :
          AdvancePaymentDetails?.Booking?.Contact?.MobileNo
        : ''}
        </td>`: '',
    '!!emailtd!!': DebtorFolioInfo === null ? `<td style="font-size:10px; font-weight: 400;    width:50%;">
         Email &nbsp;&nbsp;: ${AdvancePaymentDetails ?
        OutGoingDocTemplate !== null ? 'N/A'
          : AdvancePaymentDetails?.Booking?.Contact?.Email
        : ''}
       </td>`: '',
    '!!SubTotal!!': isnegativeamount(conditionSub, ''),
    '!!NewItem!!': EachFolioItem,

    '!!NewItem2!!': newitem2,

    '!!ServiceCharge!!': GetServiceChargeTax['Value'],
    '!!TotalServiceCharge!!': amtStr(0),
    '!!Tax!!': GetCurrentGovTax['Value'],
    '!!TotalGovTax!!': amtStr(0),
    '!!TotalRounding!!':
      `<td style="
    font-weight: 300; padding-left: 6px;">Rounding</td>
       <td style="
       font-weight: 300;  item-align:right;text-align: right;">${amtStr(0)}</td>`
    ,
    '!!TotalTourismTax!!': amtStr(0),
    '!!TaxType!!': '',

    '!!TourismTaxType!!': '',
    '!!TaxTypeAmount!!': amtStr(0),
    '!!TotalAmount!!': isnegativeamount(Number(AdvancePaymentDetails?.Amount), ''),
    '!!QtyHeader!!': '',
    '!!OutStandingBalance!!':
      outstandingbalanceFunc()
    ,
    '!!BankDetail!!': ``,
    '!!IsSmfooter!!': `    	
  <hr style="padding-right:10px;" />
  <table width="100%" border="0" cellspacing="0" cellpadding="0" style="padding-top:10px; padding-bottom:10px;">
  <td style="font-size:10px; font-weight: 400;   line-height: 15px; width:25%; text-align: justify; color:#2c2c2c"> * I agree that <span style="font-weight: bold;">i</span> am personally liable for the payment of the following statement and if the person, company or association indicated by me as being responsible for payment of the same does not do so, that my liability for such payment shall be joint and several with such person, company or association. </td>
  <td style="font-size:10px; font-weight: 400;  line-height: 15px; width:20%; text-align: right;"></td>
  <td style="font-size:10px; font-weight: 400;   line-height: 15px; width:25%; text-align: left; color:#2c2c2c">
  <hr style="padding-right:10px;" > Guest Signature
  </td>
  </tr>
  </table>`,
    '!!customheightfooter!!': `20%`, //beta
    '!!customheightcontent!!': `220px`,
    '!!TaxSchemeItem!!': OutGoingDocTemplate?.Folio ? HotelMayaTaxItem || '' : data || '',
    '!!InvoiceRemark!!': HotelDetails?.DocumentRemark?.replace(/<p/g, '<div')?.replace(/<\/p>/g, '</div>') || '',
    '!!eInvoiceQR!!' : eInvoiceQr(), 
    '!!UID!!' : eInvoiceUniqueID(),
    '!!ExternalOutlet!!': '',
    '!!AmountItem!!': AmountItem,
    '!!OriginalDocNo!!': '',
    '!!Reason!!': '',
    '!!NonGuestRemark!!': '',
    '!!DocumentReference!!': ''
  }
  let Hoteltemplate
  var FormContent =
    HotelXFolio?.replace(
      /!!FOLIO!!|!!HotelImage!!|!!FolioNo!!|!!SubTotal!!|!!NewItem!!|!!NewItem2!!|!!TotalAmount!!|!!TotalTourismTax!!|!!TotalGovTax!!|!!TotalRounding!!|!!TotalServiceCharge!!|!!TaxTypeAmount!!|!!TaxType!!|!!TourismTaxType!!|!!Tax!!|!!ServiceCharge!!|!!AgentName!!|!!GuestAddress!!|!!IdentityCard!!|!!CashierName!!|!!SSTRegNo!!|!!TTXRegNo!!|!!TINNo!!|!!HotelWebsite!!|!!HotelMobileNo!!|!!HotelEmail!!|!!HotelAddress!!|!!BookingNo!!|!!DepartureTime!!|!!DepartureDate!!|!!GuestName!!|!!HotelName!!|!!Date!!|!!RoomNo!!|!!ArrivalTime!!|!!GuestMobileNo!!|!!ArrivalDate!!|!!GuestEmail!!|!!BeneficiaryName!!|!!BeneficiaryAddress!!|!!TaxSchemeItem!!|!!InvoiceRemark!!|!!eInvoiceQR!!|!!UID!!|!!ExternalOutlet!!|!!AmountItem!!|!!OriginalDocNo!!|!!Reason!!|!!NonGuestRemark!!|!!DocumentReference!!/gi,
      function (matched) {
        // var x = mapObj[matched]
        // console.log(x)
        return mapObj[matched]
      }
    )
  console.log(FormContent, 'FormContent')
  const printForm = () => {
    var win = window?.open()
    win?.document?.write(FormContent)
    win?.document?.close()
    setTimeout(() => {
      win?.print()
    }, 100)
  }


  const paymentFolioSelection = type => {
    dispatch({
      type: 'DocSelectionDialog',
      payload: true,
    })
    dispatch({
      type: 'ButtonType',
      payload: type,
    })
    dispatch({
      type: 'DocList',
      payload: [AdvancePaymentDetails?.Folio?.FolioNo,],
    })
    dispatch({
      type: 'DocSelected',
      payload: AdvancePaymentDetails?.Folio?.FolioNo,
    })
  }
  const docSelectionPrint = () => {
    let Template =
      // FolioDetails?.Payment?.filter(x => x.PaymentClass === 'Refund').length > 0
      //   ? state.DocSelected.startsWith('HTRF')
      //     ? FormContent
      //     : state.DocSelected.startsWith('INV')
      //     ? InvoiceTemplate
      //     : ''
      //   : state.DocSelected.startsWith('INV')
      //   ? FormContent
      //   : ''
      FormContent
    console.log(Template)
    var win = window?.open()
    win?.document?.write(Template)
    win?.document?.close()
    setTimeout(() => {
      win?.print()
    }, 100)
  }
  //! Share
  const docSelectionShare = () => {
    const blobInvoice = htmlConverter({
      FormContent,
      Name:
        'Folio' + AdvancePaymentDetails?.Folio?.FolioNo,
    })
    const TemplateBlob = blobInvoice
    setSimple(true)
    onSubmit(TemplateBlob)
  }
  const defaultShare = () => {
    const blob = htmlConverter({
      FormContent,
      Name:
        'Folio' + AdvancePaymentDetails?.Folio?.FolioNo,
    })
    setSimple(true)
    onSubmit(blob)
  }

  let customcomponent = false
  const iscustom = OutGoingDocTemplate ? true : false
    const CustomBidocumentComponentHandler = () => {
      if (HotelDetails?.ID === 'a75ad068-a334-4a7e-ad4b-5d93894ed230' || HotelDetails?.ID === 'ccc26b4d-5da4-4436-b5a2-e1a5803103d1' || HotelDetails?.ID === 'f6b932aa-dff6-4d47-b9d2-bbd5314dddc9') {// maya | una | sunway
        customcomponent = true
  
        return <AdvanceForfeitDocumentMaya mode={mode} type={type} />;
      } else if (HotelDetails?.ID === '683b1eba-aad4-4b3e-aeee-c4a99f1a23a5' || HotelDetails?.ID === '33158493-a408-4084-9f45-8bad2a9a5319') {//phkk | syafiqhotel
        customcomponent = true
        return <AdvanceForfeitDocumentPHKK mode={mode} type={type} />;
      } else if (HotelDetails?.ID === 'e46fd9f2-ec0a-47bc-a214-a3ea843f20c6') {//phbtu
        customcomponent = true
        return <AdvanceForfeitDocumentPHB mode={mode} type={type} />;
      } else if (HotelDetails?.ID === '4cbd20d7-d2d0-47ea-a006-3703f65664cc' || HotelDetails?.ID === 'b7bd96bc-bd33-4650-8c49-577fea38bc94' || HotelDetails?.ID === 'cc7adbff-d42b-4bd3-a765-fbd96bc69369') { // Hotel123 | imperialnew | imperialold
        customcomponent = true
        return <AdvanceForfeitDocumentImperial mode={mode} type={type} />;
      }  
      else {
        customcomponent = false
        return (<>
       <div
          style={{ fontSize: 12, padding: 5 }}
          dangerouslySetInnerHTML={{
            __html: FormContent,
          }}
        ></div>
        </>
          
        );
      }
    };
  return loading || loadingSum || loadingInsert ? (
    <Loading />
  ) : (
    <>
      <MainHeader
        mainBtn="back"
        onClick={() => {
          stateInfo?.mode || type === 'Checkout Adjustment'
            ? history.goBack()
            : history.push('/businessinsight/digitaldocument/folio', {
              StartDate: stateInfo.StartDate,
              EndDate: stateInfo.EndDate,
              name: stateInfo.name,
            })
        }}
        smTitle="HMS"
        title={JSON.parse(localStorage.getItem('Hotel'))?.HotelName}
        routeSegments={[
          { name: 'Digital Document' },
          { name: 'Digital Document' },
          { name: 'Folio', current: true },
        ]}
      // rightRouteSegments={[
      //   {
      //     name: `${
      //       FolioDetails !== null
      //         ? FolioDetails?.FolioNo
      //         : FolioDetailsWithIDs?.Booking?.BookingNo
      //     }`,
      //     current: true,
      //   },
      // ]}
      />

      <ContentWrapper float>
        {CustomBidocumentComponentHandler()}
      </ContentWrapper>
      {
  customcomponent ? null
  : (<>
      {ShareDialog({
        ShareTitle: ShareButton.title,
        Title: `Share ${type ? type : 'Folio'}--${AdvancePaymentDetails?.Folio?.FolioNo
          }`,
        URL: ShareButton.url,
        setSimple: setSimple,
        simple: simple,
        EmailShare: emailShare,
        setSimpleEmail: setSendEmail,
      })
      }
      {ShareDialog({
        ShareTitle: ShareButton.title,
        Title: `Share ${type ? type : 'Folio'}--${AdvancePaymentDetails?.Folio?.FolioNo
          }`,
        URL: ShareButton.url,
        setSimple: setSimple,
        simple: simple,
        EmailShare: emailShare,
        setSimpleEmail: setSendEmail,
      })}
      <DocSelectionDialog
        state={state}
        dispatch={dispatch}
        docSelectionPrint={docSelectionPrint}
        docSelectionShare={docSelectionShare}
      />
      <Footer
        options={[
          {
            name: 'Share',
            disabled: handlePermDisabled({
              hotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
              permEnum:
                HotelPermission.BusinessInsightDigitalDocumentFolioShare,
            }),

            onClick: () =>
              stateInfo?.Page === 'PaymentFolio'
                ? paymentFolioSelection('Share')
                : defaultShare(),
            color: 'primary',
          },
          {
            name: 'print',
            disabled: handlePermDisabled({
              hotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
              permEnum:
                HotelPermission.BusinessInsightDigitalDocumentFolioPrint,
            }),
            onClick: () =>
              stateInfo?.Page === 'PaymentFolio'
                ? paymentFolioSelection('Print')
                : printForm(),
            color: 'primary',
          },
        ]}
      />
        </>)
}
      <SnackBarMsg open={openSnackBar} message={snackBarMessage} />
    </>
  )
}
